import React from 'react';
import { useForm } from 'react-hook-form';
import { SwitchField } from 'components/form/rhf';
import { AiAssistantFormValues } from '../types';

interface Props {
  isLoading: boolean;
  defaultValues: AiAssistantFormValues;
  onConfirm: (values: AiAssistantFormValues) => Promise<void>;
}

export const AiAssistantForm = ({ isLoading, defaultValues, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<AiAssistantFormValues>({ defaultValues });

  return (
    <SwitchField<AiAssistantFormValues>
      control={control}
      name="aiAssistantEnabled"
      label="Enable AI Assistant for this account"
      disabled={isLoading}
      extraAction={() => handleSubmit(onConfirm)()}
    />
  );
};
